document.addEventListener("DOMContentLoaded", async () => {
  // DD START
  const ddContainer = document.querySelector(".pc-pro-dropdown-container");
  const ddContent = document.querySelector(".pc-pro-dropdown-content");
  const collectionHandle = ddContent.dataset.collectionHandle;
  const bestSellersTitle = ddContent.dataset.bestSellersTitle;
  const makesTitle = ddContent.dataset.makesTitle;
  const noVehicleFoundText = ddContent.dataset.noVehicleFound;
  const ddList = document.querySelector(".pc-pro-dd-list");
  const ddSelections = document.querySelector(".pc-pro-selection-container");
  const ddButton = document.querySelector(".dropdown-button");
  const makeModels = await getMakeModels();
  const bestSellerMakes = ddContent.dataset.bestSellers?.split(",");
  const filteredMakes = Object.keys(makeModels).filter(
    (make) => !bestSellerMakes.includes(make)
  );
  const fixedButtonContainer = document.querySelector(
    ".c-hd-trucks__fixed-button-container"
  );
  const fixedButton = document.querySelector(
    ".c-hd-trucks__fixed-button-container button"
  );

  fixedButton.addEventListener("click", () => {
    ddButton.scrollIntoView({ behavior: "smooth", block: "center" });
    openDropdown();
  });
  let animationFrameId;
  function checkRichPanel() {
    const richPanelIcon = document.querySelector(
      ".rp-micro-app-dummy-icon-container"
    );
    if (richPanelIcon) {
      fixedButton.style.width = "calc(100% - 100px)";
    } else {
      animationFrameId = requestAnimationFrame(checkRichPanel);
    }
  }
  const timeoutId = setTimeout(() => {
    cancelAnimationFrame(animationFrameId);
  }, 10000);
  checkRichPanel();

  window.addEventListener("scroll", () => {
    const rect = ddButton.getBoundingClientRect();
    const isInView = rect.top >= 0 && rect.top <= window.innerHeight;
    if (isInView) {
      fixedButtonContainer.style.display = "none";
    } else {
      fixedButtonContainer.style.display = "block";
    }
  });

  getInitialDropdown({ addSearchBar: true });

  ddButton.addEventListener("click", handleDropdownButtonClick);

  // FUNCTIONS START

  function handleKeydown(e) {
    const highlightedElement = ddContent.querySelector(
      ".pc-pro-dd-list-item.highlight"
    );
    const focusableElements = ddContent.querySelectorAll(
      ".pc-pro-dd-list-item:not(.pc-pro-dd-search-bar-li):not(.pc-pro-dd-list-splitter):not(.no-hover)"
    );
    switch (e.key) {
      case "Escape":
        closeDropdown();
        highlightedElement?.classList.remove("highlight");
        break;
      case "ArrowDown": {
        e.preventDefault();
        ddContent.dataset.keyboardControls = "true";
        const nextElement = highlightedElement?.nextElementSibling;
        if (!nextElement) {
          const elementToFocus = focusableElements[0];
          elementToFocus.classList.add("highlight");
          centerElementInContainer(elementToFocus, ddList);
        } else {
          highlightedElement.classList.remove("highlight");
          nextElement.classList.add("highlight");
          centerElementInContainer(nextElement, ddList);
        }
        break;
      }
      case "ArrowUp": {
        e.preventDefault();
        ddContent.dataset.keyboardControls = "true";
        const previousElement = highlightedElement?.previousElementSibling;
        if (!previousElement) {
          const elementToFocus =
            focusableElements[focusableElements.length - 1];
          elementToFocus.classList.add("highlight");
          centerElementInContainer(elementToFocus, ddList);
        } else {
          highlightedElement.classList.remove("highlight");
          previousElement.classList.add("highlight");
          centerElementInContainer(previousElement, ddList);
        }
        break;
      }
      case "Enter":
        e.preventDefault();
        highlightedElement.click();
        break;
    }
  }

  function centerElementInContainer(element, container) {
    const elementRect = element.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    const offset =
      elementRect.top -
      containerRect.top -
      containerRect.height / 2 +
      elementRect.height / 2;
    container.scrollTop += offset;
  }
  function getInitialDropdown({ addSearchBar }) {
    if (addSearchBar) {
      appendSearchBar();
    }
    ddList.style.height = "";
    // const bestSellersSplitter = getSplitter({ text: bestSellersTitle });
    // ddList.append(bestSellersSplitter);
    // fillListMakes(bestSellerMakes);

    // const makesSplitter = getSplitter({ text: makesTitle });
    // ddList.append(makesSplitter);
    if (filteredMakes.length == 1) {
      fillListModels(filteredMakes[0]);
    } else {
      fillListMakes(filteredMakes);
    }
  }

  function handleDropdownButtonClick() {
    const isOpened = ddContent.dataset.dropdownOpened === "true";
    if (isOpened) {
      closeDropdown();
    } else {
      openDropdown();
    }
  }

  function openDropdown() {
    ddContent.dataset.dropdownOpened = true;
    ddContent.querySelector(".pc-pro-search-bar")?.focus();
    setDropdownHeight();
    window.addEventListener("keydown", handleKeydown);
    window.addEventListener("click", handleDocumentClick);
  }

  function closeDropdown() {
    ddContent.dataset.dropdownOpened = false;
    window.removeEventListener("keydown", handleKeydown);
    window.removeEventListener("click", handleDocumentClick);
    ddContent.dataset.keyboardControls = "false";
  }

  function handleDocumentClick(e) {
    console.log(e);
    const closestDropdownContent = e.target.closest(".pc-pro-dropdown-content");
    if (
      !closestDropdownContent &&
      !e.target.classList.contains("pc-pro-dd-list-item") &&
      e.target !== fixedButton
    ) {
      closeDropdown();
    }
  }

  function fillListMakes(items) {
    items.forEach((item) => {
      const liElement = getMakeListItem({ make: item });
      ddList.append(liElement);
    });
  }

  function fillListModels(make) {
    const models = makeModels[make];
    clearDD();
    models.forEach((model) => {
      const liElement = getModelListItem({ model, link: `${make} ${model}` });
      ddList.append(liElement);
    });
    // console.log(models);
  }

  function clearDD() {
    const totalChildren = ddList.children.length;
    for (let i = totalChildren - 1; i > 0; i--) {
      ddList.removeChild(ddList.children[i]);
    }
  }

  function appendSearchBar() {
    const li = document.createElement("li");
    li.classList.add("pc-pro-dd-list-item", "pc-pro-dd-search-bar-li");
    const input = document.createElement("input");
    input.type = "text";
    input.classList.add("pc-pro-search-bar");
    input.addEventListener("input", handleSearchBarChange);
    input.placeholder = "Search";
    li.append(input);
    ddList.append(li);
  }

  function handleSearchBarChange(e) {
    const searchValue = e.target.value.toLowerCase();
    ddList.style.height = "";

    clearDD();
    if (searchValue === "") {
      getInitialDropdown({ addSearchBar: false });
      setDropdownHeight();
      return;
    }
    const foundArray = [];
    Object.keys(makeModels).forEach((make) => {
      const models = makeModels[make];

      if (make.toLowerCase().includes(searchValue)) {
        foundArray.push({ type: "make", name: make });
      }

      models.forEach((model) => {
        if (model.toLowerCase().includes(searchValue)) {
          foundArray.push({ type: "model", name: `${make} ${model}` });
        }
      });
    });

    if (foundArray.length < 5) {
      const newHeight = 68 + foundArray.length * 52 + "px";
      ddList.style.height = newHeight;
    }

    if (foundArray.length < 1) {
      const listItem = getListItem({ text: noVehicleFoundText });
      ddList.append(listItem);
      ddList.style.height = "120px";
      return;
    }

    foundArray.sort((a, b) => {
      if (a.type === "make" && b.type === "model") return -1;
      if (a.type === "model" && b.type === "make") return 1;
      return 0;
    });
    foundArray.forEach((item) => {
      if (item.type === "make") {
        const makeLi = getMakeListItem({ make: item.name });
        ddList.append(makeLi);
      } else {
        const modelLi = getModelListItem({ model: item.name, link: item.name });
        ddList.append(modelLi);
      }
    });
    setDropdownHeight();
  }

  function getSplitter({ text }) {
    const li = document.createElement("li");
    li.classList.add("pc-pro-dd-list-item", "pc-pro-dd-list-splitter");
    li.innerText = text;
    return li;
  }

  function getMakeListItem({ make }) {
    const li = document.createElement("li");
    li.classList.add("pc-pro-dd-list-item");
    li.innerText = make;
    li.addEventListener("click", () => {
      removeSelectionItems();
      if (makeModels[make].length < 5) {
        const newHeight = 68 + makeModels[make].length * 52 + "px";
        ddList.style.height = newHeight;
      } else {
        ddList.style.height = "";
      }
      createSelectionItem({ text: make });
      fillListModels(make);
      document.querySelector(".pc-pro-search-bar").value = "";
    });
    addHighlightEventListeners(li);
    return li;
  }
  function getModelListItem({ model, link }) {
    const li = document.createElement("li");
    li.classList.add("pc-pro-dd-list-item");
    li.innerText = model;
    li.addEventListener("click", () => {
      redirectToProductPage(link);
    });
    addHighlightEventListeners(li);
    return li;
  }

  function addHighlightEventListeners(el) {
    el.addEventListener("mouseenter", () => {
      const isKeyboardMode = ddContent.dataset.keyboardControls === "true";
      if (!isKeyboardMode) {
        el.classList.add("highlight");
      }
    });
    el.addEventListener("mouseleave", () => {
      const isKeyboardMode = ddContent.dataset.keyboardControls === "true";
      if (!isKeyboardMode) {
        el.classList.remove("highlight");
      }
    });
  }

  function getListItem({ text }) {
    const li = document.createElement("li");
    li.classList.add("pc-pro-dd-list-item", "no-hover");
    li.innerText = text;
    return li;
  }

  function redirectToProductPage(makeModel) {
    const changedMakeModel = makeModel.toLowerCase().replaceAll(" ", "-");
    window.location = `${window.Shopify.routes.root}products/${changedMakeModel}`;
  }

  function removeSelectionItems() {
    ddSelections.innerHTML = "";
  }
  function createSelectionItem({ text }) {
    const div = document.createElement("div");
    const cross = document.createElement("button");
    cross.classList.add("pc-pro-selection-delete");
    cross.addEventListener("click", () => {
      clearDD();
      getInitialDropdown({ addSearchBar: false });
      div.classList.remove("visible");
      setTimeout(() => {
        div.remove();
      }, 200);
    });
    const textEl = document.createElement("p");
    div.classList.add("pc-pro-selection-item");
    textEl.innerText = text;
    div.append(textEl, cross);
    ddSelections.append(div);
    setTimeout(() => {
      div.classList.add("visible");
    }, 20);
  }

  async function fetchAllProducts() {
    let hasNextPage = true;
    let endCursor = null;
    let allVariants = [];
    const endpoint = `/api/2024-07/graphql`;
    const headers = {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": "960b68e3d27e55870e9ad333d5a199a1",
    };
    const fetchProducts = async (cursor = null) => {
      const query = `
      {
        collectionByHandle(handle: "${collectionHandle}") {
          products(first: 250${cursor ? `, after: "${cursor}"` : ""},) {
            pageInfo {
              hasNextPage
              endCursor
            }
            nodes {
              vendor
              variants(first: 1) {
                nodes {
                  title
                }
              }
              
            }
          }
        }
      }
      `;
      try {
        const response = await fetch(endpoint, {
          method: "POST",
          headers: headers,
          body: JSON.stringify({ query }),
        });

        const data = await response.json();
        // console.log(data);
        return data.data.collectionByHandle.products;
      } catch (error) {
        console.log(error);
        console.error("Error fetching GraphQL data:", error);
      }
    };

    while (hasNextPage) {
      const productsData = await fetchProducts(endCursor);
      allVariants = allVariants.concat(
        productsData.nodes.map((node) => node.variants.nodes[0].title)
      );
      hasNextPage = productsData.pageInfo.hasNextPage;
      endCursor = productsData.pageInfo.endCursor;
    }
    return allVariants;
  }

  async function getMakeModels() {
    const allVariants = await fetchAllProducts();

    const makes = {};
    allVariants.forEach((variant) => {
      const [pcCode, make, model, year, engine] = variant
        .split("/")
        .map((item) => item.trim());
      if (!pcCode.startsWith("PC")) return;
      if (!makes[make]) {
        makes[make] = [model];
      } else {
        makes[make].push(model);
      }
    });
    const orderedMakes = {};
    Object.keys(makes).map((key) => {
      const orderedModels = makes[key].sort();
      orderedMakes[key] = orderedModels;
    });
    return orderedMakes;
  }

  function setDropdownHeight() {
    const children = ddList.querySelectorAll(".pc-pro-dd-list-item");
    let totalHeight = 0;
    children.forEach((child) => {
      totalHeight += child.offsetHeight;
    });
    const newHeight = Math.min(totalHeight + 16, 324) + "px";
    ddList.style.height = newHeight;
  }

  // DD END

  // CARDS START
  const productSlider = new Swiper(".c-hd-trucks__product-slider", {
    slidesPerView: 1.3,
    spaceBetween: 10,
    breakpoints: {
      460: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      550: {
        slidesPerView: 2.2,
        spaceBetween: 10,
      },
      710: {
        slidesPerView: 3,
        spaceBetween: 5,
      },
      915: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 10,
      },
    },
    navigation: {
      nextEl: ".c-hd-trucks__product-slider .swiper-button-next",
      prevEl: ".c-hd-trucks__product-slider .swiper-button-prev",
    },
  });

  const cardButtons = document.querySelectorAll(
    ".c-hd-trucks__product-card-cta"
  );
  cardButtons.forEach((cardButton) => {
    cardButton.addEventListener("click", async (e) => {
      e.preventDefault();
      const productHandle = cardButton.dataset.productHandle;
      showLoader(cardButton);
      await displayVariants(productHandle);
    });
  });

  function showLoader(clickedButton) {
    const loader = clickedButton
      .closest(".c-hd-trucks__product-card")
      .querySelector(".c-hd-trucks__product-card-overlay");
    loader.classList.remove("hidden");
    loader.classList.remove("invisible");
  }

  async function displayVariants(productHandle) {
    const url = `${Shopify.routes.root}products/${productHandle}.js`;
    const product = await fetch(url).then((response) => response.json());
    const variants = product.variants;
    createVariantButtons(productHandle, variants);
  }

  function createVariantButtons(productHandle, variants) {
    const button = document.querySelector(
      `.c-hd-trucks__product-card-cta[data-product-handle="${productHandle}"]`
    );

    const overlay = button
      .closest(".c-hd-trucks__product-card")
      .querySelector(".c-hd-trucks__product-card-overlay");

    const loader = overlay.querySelector(".loader");
    const buttons = variants.map((variant) => {
      return getVariantButton(variant);
    });

    loader.remove();
    overlay.classList.add("buttons"); // REMOVES ALIGN ITEMS CENTER SO BUTTONS STRETCH TO FULL WIDTH
    overlay.append(...buttons);

    function getVariantButton(variant) {
      const button = document.createElement("button");
      button.classList.add("c-hd-trucks__product-card-variant-button");
      const [pc, year, make, model, engine] = variant.title.split(" / ");
      button.innerHTML = `<div class="c-hd-trucks__product-card-model">${model}</div><div class="c-hd-trucks__product-card-engine">${engine}</div>`;
      button.addEventListener("click", () => {
        redirectPPFunc(
          String(variant.id),
          `${Shopify.routes.root}products/${productHandle}`,
          pc,
          year
        );
      });
      return button;
    }
  }

  // CARDS END
});

function redirectPPFunc(id, href, pc, year) {
  window.localStorage.setItem(
    "hpValues",
    JSON.stringify({ id, selection: `${pc} / ${year}` })
  );
  window.location.href = href;
}
